(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-nurv"] && !Shopify.designMode) return;
  try {
    
  class HeroTypewriter extends HTMLElement {
    connectedCallback() {
      this.typewriterEl = this.querySelector('[data-typewriter]');
      this.accentEl = this.querySelector('[data-typewriter-accent]');
      if (!this.typewriterEl) return;
      
      this.mainText = this.typewriterEl.dataset.typewriter;
      this.accentText = this.accentEl ? this.accentEl.dataset.typewriterAccent : '';
      this.speed = 50;
      
      // Start typing when element is in view
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.typeMain(0);
            observer.disconnect();
          }
        });
      }, { threshold: 0.5 });
      
      observer.observe(this.typewriterEl);
    }
    
    typeMain(index) {
      if (index < this.mainText.length) {
        this.typewriterEl.textContent += this.mainText.charAt(index);
        setTimeout(() => this.typeMain(index + 1), this.speed);
      } else {
        // Main text done, start accent after short pause
        this.typewriterEl.classList.add('typing-done');
        if (this.accentEl && this.accentText) {
          setTimeout(() => {
            this.accentEl.classList.add('typing');
            this.typeAccent(0);
          }, 300);
        }
      }
    }
    
    typeAccent(index) {
      if (index < this.accentText.length) {
        this.accentEl.textContent += this.accentText.charAt(index);
        setTimeout(() => this.typeAccent(index + 1), this.speed);
      } else {
        // Typing complete - hide cursor after a delay
        setTimeout(() => {
          this.accentEl.classList.remove('typing');
          this.accentEl.classList.add('typing-done');
        }, 1500);
      }
    }
  }
  
  customElements.define('hero-typewriter', HeroTypewriter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
